// extracted by mini-css-extract-plugin
export var currencyInput = "_jk-1";
export var currencySymbol = "_jk-0";